import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { CampaignSearchResponse } from '../models/campaign-management.model';

export const CancelCampaignExecution = createAction('[Campaign Management: Search]: Cancel Campaign Execution');

export const CancelCampaignExecutionSuccess = createAction(
  '[Campaign Management: Search]: Cancel Campaign Execution Success',
  props<{ res: CampaignSearchResponse }>(),
);

export const CancelCampaignExecutionFailed = createAction(
  '[Campaign Management: Search]: Cancel Campaign Execution Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const CloseCancelCampaignModal = createAction('[Campaign Management: Search]: Close Cancel Campaign Modal');
